import ScreenPromotedAdPackagesList from 'screens/PromotedAdPackages/List';
import ScreenPromotedAdPackagesCreate from 'screens/PromotedAdPackages/Create';
import { PROMOTED_AD_PACKAGES } from 'routes/paths';

const promotedAdPackagesRoutes = [
  {
    path: PROMOTED_AD_PACKAGES.LIST,
    name: 'PromotedAdPackagesList',
    component: ScreenPromotedAdPackagesList,
    allowPermissions: ['list_promotedadpackage'],
  },
  {
    path: PROMOTED_AD_PACKAGES.CREATE,
    name: 'PromotedAdPackagesCreate',
    component: ScreenPromotedAdPackagesCreate,
    allowPermissions: ['add_promotedadpackage'],
  },
];

export default promotedAdPackagesRoutes;
